import { render, staticRenderFns } from "./vme-statistic.html?vue&type=template&id=2b80d450&scoped=true&external"
import script from "./vme-statistic.ts?vue&type=script&lang=ts&external"
export * from "./vme-statistic.ts?vue&type=script&lang=ts&external"
import style0 from "./vme-statistic.scss?vue&type=style&index=0&id=2b80d450&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80d450",
  null
  
)

/* custom blocks */
import block0 from "./vme-statistic.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fhome%2Fvme-iframe%2Fvme-statistic%2Fvme-statistic.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
